<template>
  <div>
    <el-dialog width="1020px" :visible.sync="visible" @open="onModalOpen" @closed="onModalClose">
      <div class="title-header" slot="title">
        <div class="header-text">落地页选择</div>
        <div v-show="selection.length > 0" class="nums">已选{{ selection.length }}个</div>
      </div>

      <div class="top-form">
        <el-form ref="formInline" inline @submit.native.prevent="() => {}">
          <el-form-item>
            <ThrottleSelector
              :popper-append-to-body="false"
              v-model="formItem.gameId"
              @change="newQuery"
              :list="GAMES"
              style="width: 160px"
              placeholder="全部"
              filterable
              clearable
            />
          </el-form-item>
          <el-form-item>
            <ThrottleSelector
              :popper-append-to-body="false"
              v-model="formItem.opId"
              @change="newQuery"
              :list="PTOM_USERS"
              style="width: 160px"
              placeholder="全部"
              filterable
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formItem.keyword"
              placeholder="输入落地页名称"
              clearable
              style="width: 260px"
              @keyup.enter.native="newQuery"
              @clear="newQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="newQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div class="btns">
          <el-button type="text" class="btn refresh" @click="newQuery">刷新</el-button>
          <el-button type="text" class="btn add" @click="addTitle()">+新增落地页包</el-button>
        </div>
      </div>

      <div class="main-table">
        <div style="position: relative" v-loading="tableLoading">
          <el-table
            :data="tableData"
            :height="360"
            ref="table"
            @selection-change="onTableSelectChange"
            @row-click="onTableRowClick"
            border
            style="width: 100%"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column prop="id" label="落地页包ID" width="90"></el-table-column>
            <el-table-column prop="packName" label="落地页包名称" width="110" show-overflow-tooltip> </el-table-column>
            <el-table-column label="落地页地址" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <div v-for="(url, index) in row.contents" :key="index">
                  <el-button @click.stop="previewAction(url)" type="text">{{ url }}</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="opName" label="创建人" width="60" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="130">
              <template slot-scope="{ row }">
                <div>
                  {{ row.createTime | datetimeToMin }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="{ row }">
                <el-button type="text" @click.stop="onRowEdit(row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pager">
          <div class="error-msg">
            <span v-show="errorMsg"> {{ errorMsg }}</span>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="pager.page.pageIndex"
            :page-size="pager.page.pageSize"
            :total="pager.total"
            @current-change="query"
          >
          </el-pagination>
        </div>
      </div>

      <div class="footer">
        <el-button @click="closeModal">取消</el-button>&ensp;
        <el-button @click="onConfirm" type="primary">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="`${modalType === 2 ? '编辑' : '新增'}落地页包`"
      width="780px"
      :visible.sync="addDialogVisible"
      @close="closeAddFormModal"
    >
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="140px">
        <el-form-item label="落地页包名称" prop="packName">
          <el-input style="width: 360px" v-model="addForm.packName" placeholder="请输入落地页包名称"></el-input>
        </el-form-item>

        <el-form-item label="媒体" prop="mediaId">
          <el-select style="width: 360px" v-model="addForm.mediaId" :popper-append-to-body="false" filterable placeholder="全部">
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="游戏" prop="gameId">
          <el-select
            style="width: 360px"
            v-model="addForm.gameId"
            :popper-append-to-body="false"
            clearable
            collapse-tags
            multiple
            filterable
            placeholder="全部"
          >
            <el-option v-for="item in GAMES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <div class="textarea-wrapper">
            <div class="mark-rows">
              <div class="line-mark" v-for="num in lines" :key="num">{{ num }}</div>
            </div>

            <div class="input-rows" ref="inputsRef">
              <input class="line-input" @keypress.enter="onInputKeyPress(num)" v-for="num in lines" :key="num" />
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button @click="closeAddFormModal">取消</el-button>&ensp;
        <el-button @click="onAddConfirm" type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { getLandingPagePackages, addLandingPagePackage, updateLandingPagePackage } from '@/api/landpage.model'
import { initPageData, GAMES, PTOM_USERS, MEDIAS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([GAMES, PTOM_USERS, MEDIAS])
const MODAL_TYPE = {
  ADD: 1,
  UPDATE: 2
}
export default {
  components: { ThrottleSelector },
  props: {
    value: {
      type: Boolean
    },
    opId: {
      type: Number
    },
    gameId: {
      type: Number
    },
    mediaId: {
      type: Number
    },
    limit: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      modalType: MODAL_TYPE.ADD,
      addFormRules: {
        packName: [
          { required: true, message: '请输入落地页包名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        mediaId: [{ required: true, message: '请选择媒体', trigger: 'change' }],
        gameId: [{ required: true, message: '请选择游戏', trigger: 'change' }]
      },
      lines: Array(10)
        .fill(1)
        .map((_, i) => i + 1),
      addDialogVisible: false,
      errorMsg: '',
      selection: [],
      pager: {
        total: 0,
        page: {
          pageIndex: 1,
          pageSize: 20
        }
      },
      tableLoading: false,
      tableData: [],
      addForm: {
        packName: '',
        mediaId: 10,
        gameId: []
      },
      formItem: {
        keyword: '',
        gameId: '',
        mediaId: '',
        opId: ''
      }
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    visible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    /**
     * @description: 回车模拟换行
     * @param {*} idx
     * @return {*}
     */
    onInputKeyPress(idx) {
      if (idx < 10) this.$refs.inputsRef.children[idx].focus()
    },
    /**
     * @description: 页码重置后搜索
     * @return {*}
     */
    newQuery() {
      this.$nextTick(() => {
        this.pager.page.pageIndex = 1
        this.query()
      })
    },
    /**
     * @description: 查询落地页列表
     * @return {*}
     */
    query() {
      this.tableLoading = true
      getLandingPagePackages({
        ...this.pager.page,
        ...this.formItem
      }).then((data) => {
        this.tableLoading = false
        const { list, page_info } = data
        this.tableData = list?.map((item) => ({ ...item, contents: JSON.parse(item.content) })) || []
        this.pager.total = page_info?.total_number || 0
      })
    },

    onTableRowClick(row) {
      if (this.limit === 1) {
        this.$refs.table.clearSelection()
      }
      this.$refs.table.toggleRowSelection(row)
    },
    onTableSelectChange(selection) {
      this.selection = selection
    },
    /**
     * @description: 跳转至落地页新建页面
     * @return {*}
     */
    addTitle(row) {
      this.addDialogVisible = true

      if (row && row.id) {
        this.addForm = {
          id: row.id,
          packName: row.packName,
          mediaId: Number(row.mediaIds),
          gameId: row.gameIds.split(',').map((id) => Number(id))
        }

        this.modalType = MODAL_TYPE.UPDATE
        this.$nextTick(() => {
          const inputs = this.$refs.inputsRef.children
          row.contents.forEach((text, index) => {
            inputs[index].value = text
          })
        })
      } else {
        this.modalType = MODAL_TYPE.ADD
      }
    },
    /**
     * @description: 游戏选择后触发的回调
     * @param {*} id
     * @return {*}
     */
    onGameChange({ id }) {
      this.formItem.gameId = id || ''
      this.newQuery()
    },
    previewAction(url) {
      window.open(url, '_blank')
    },
    onAddConfirm() {
      let content = []
      const inputs = this.$refs.inputsRef
      if (inputs && inputs.children.length) {
        content = Array.from(inputs.children)
          .map((i) => i.value)
          .filter((i) => !!i.trim())
      }

      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addSubmitLoading = true
          const { packName, mediaId, gameId } = this.addForm
          const params = {
            packName: packName.trim(),
            mediaIds: mediaId,
            gameIds: gameId.join(','),
            content
          }
          ;(this.modalType === MODAL_TYPE.ADD
            ? addLandingPagePackage(params)
            : updateLandingPagePackage({ id: this.addForm.id, ...params })
          )
            .then((data) => {
              if (data && typeof data === 'boolean') {
                this.$Message.success('添加成功')
                this.closeAddFormModal()
                this.newQuery()
              }
            })
            .finally(() => {
              this.addSubmitLoading = false
            })
        }
      })
    },
    closeAddFormModal() {
      // 清除表单校验
      this.$refs.addForm.resetFields()
      // 清空每行的文案
      const inputs = this.$refs.inputsRef
      Array.from(inputs.children || []).forEach((i) => {
        i.value = ''
      })
      // this.modalType = MODAL_TYPE.ADD
      // 关闭弹窗
      this.addDialogVisible = false

      this.addForm = {
        packName: '',
        mediaId: 10,
        gameId: ''
      }
    },
    /**
     * @description: 确认选择，至少选择一项
     * @return {*}
     */
    onConfirm() {
      const len = this.selection.length
      if (len) {
        if (len > this.limit) {
          this.errorMsg = `最多选择${this.limit}个落地页`
        }
        this.$emit('confirm', this.selection)
        this.closeModal()
      } else {
        this.errorMsg = '请至少选择一个落地页'
      }

      setTimeout(this.clearErrorMsg, 3000)
    },

    closeModal() {
      this.$refs.table.clearSelection()
      this.visible = false
    },

    onRowEdit(row) {
      this.addTitle(row)
    },
    clearErrorMsg() {
      this.errorMsg = ''
    },
    /**
     * @description: 打开弹窗获取搜索框默认值
     * @return {*}
     */
    onModalOpen() {
      if (this.gameId) this.formItem.gameId = this.gameId
      if (this.opId) this.formItem.opId = this.opId
      if (this.mediaId) this.formItem.mediaId = this.mediaId

      this.newQuery()
    },
    onModalClose() {
      this.clearErrorMsg()
    }
  }
}
</script>
<style lang="scss" scoped>
.textarea-wrapper {
  border: 1px solid #dcdee2;
  border-radius: 4px;
  display: flex;
  padding: 4px 7px;

  .mark-rows {
    text-align: right;
    margin-right: 8px;
    font-size: 12px;
    line-height: 20px;
    color: #999;
    .line-mark {
      white-space: nowrap;
    }
  }
  .input-rows {
    width: 100%;
    input {
      display: block;
      width: 100%;
      height: 20px;
      line-height: 20px;
    }
  }
  // .ivu-input-wrapper {
  //   textarea {
  //     border: none;
  //     padding: 0;
  //     line-height: 20px;
  //     font-size: 12px;
  //     &:focus {
  //       box-shadow: none;
  //     }
  //   }
  // }
}
::v-deep .el-dialog__body {
  padding-top: 5px;
}
.title-header {
  display: flex;
  align-items: center;
  .header-text {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #17233d;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .nums {
    margin-left: 10px;
  }
}
.top-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .ivu-form-item {
    margin-bottom: 0;
  }
  .btns {
    display: flex;
    align-items: center;
    .add {
      margin-left: 10px;
    }
  }
}
.main-table {
  margin-top: 10px;

  .pager {
    margin-top: 10px;
    text-align: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .error-msg {
      color: red;
      font-size: 12px;
    }
  }
}
.footer {
  margin-top: 10px;
  text-align: right;
}
</style>
